import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import axiosInstance from "../../Component/axiosInstance";
import axiosInstance from "../../../Component/axiosInstance";
import Cookies from 'js-cookie';

// Async thunk for adding a company
const editProjectionGraph = createAsyncThunk('transportDetail', async (data, { rejectWithValue }) => {
    try {
        console.log("yo hai transhport detail function ****************** ", data);
        // return ;
        const response = await axiosInstance.put(
            `/project/updateProjectGraph`,
            { count: data.data.count }, // send a proper object
            {
              headers: {
                'x-auth-token': localStorage.getItem('token'),
                'x-project-id': data.data.projectid,
                'x-updatedata-id': data.data.deleteid,
                'x-target-graph': data.data.targetname,
              }
            }
          );
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || "An unexpected error occurred");
    }
});

// Slice for managing add company state
const editProjectionGraphSlice = createSlice({
    name: 'editProjectionGraph',
    initialState: {
        loading: false,
        error: null,
        data: null,
        isSuccess: false,
        isError: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(editProjectionGraph.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.data = null;
                state.isSuccess = false;
                state.isError = false;
            })
            .addCase(editProjectionGraph.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                state.isSuccess = true;
                state.isError = false;
            })
            .addCase(editProjectionGraph.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.data = null;
                state.isError = true;
                state.isSuccess = false;
            });
    }
});

export { editProjectionGraph };
export default editProjectionGraphSlice.reducer;